import api from 'apis/restaurant-api/api';

import { InvoiceDossier, Products } from './types';

export const fetchInvoiceDossier = (venueId: string, venuePayoutId: string) =>
  api
    .get<InvoiceDossier>(`/v1/merchant-admin/venues/${venueId}/invoice-dossier/${venuePayoutId}`)
    .then(response => response.data);

export const getPdfLink = (venueId: string, payoutId: string) =>
  api.get(`v1/merchant-admin/venues/${venueId}/payouts/${payoutId}`);

export const getSupplementriesPdfLink = (venueId: string, path?: string) =>
  api
    .get(`v1/merchant-admin/venues/${venueId}/invoice-dossier/supplementaries`, { params: { path } })
    .then(response => response.data);

export const getProductSalesInvoiceForVenue = (venueId: string) =>
  api.get<Products>(`v1/merchant-admin/venues/${venueId}/products`).then(response => response.data.results);

export const generatePayoutReportCsv = (venueId: string, payoutId: string) =>
  api.post(`v1/merchant-admin/venues/${venueId}/payouts/${payoutId}/csv`);
export const getPayoutReportCsvLink = (venueId: string, payoutId: string) =>
  api.get(`v1/merchant-admin/venues/${venueId}/payouts/${payoutId}/csv`);

export const getAnnualReportCsvLink = (venueId: string, year: number) =>
  api.get(`v1/merchant-admin/venues/${venueId}/${year}/annual-csv-report`);
